import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "nav-logout-icon",
  viewBox: "0 0 24 24",
  fill: "none",
  "aria-hidden": "true"
};
export function render(_ctx, _cache) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [_createElementVNode("path", {
    d: "M3 2h14v5M3 22h14v-5M3 2v20",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "square",
    "stroke-linejoin": "miter"
  }, null, -1), _createElementVNode("path", {
    d: "M13.5 12h8M19.5 9l3.5 3-3.5 3",
    stroke: "currentColor",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  }, null, -1)]))]);
}